/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useCallback, useEffect, useState } from 'react';
import { FiEdit3, FiCopy, FiDownload } from 'react-icons/fi';

import { getAiResponse } from '../../services/api';

import {
  AlertWrapper,
  Container,
  Tabs,
  Tab,
  FormWrapper,
  Label,
  Input,
  Row,
  Column,
  Select,
  Button,
} from './styles';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

const IaActivities: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();

  const [topic, setTopic] = useState('');
  const [model, setModel] = useState('Debate Estruturado');
  const [duration, setDuration] = useState('90 Minutos');
  const [loading, setLoading] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [iaText, setIaText] = useState<string>('');

  const allowedSellersId = [
    '9c5bc316-b0de-4d84-81ca-e9696196bc5d', // longevidade
    '3887d7de-20da-4eaa-a51b-77789f1e8804', // ceuma
    '038791ea-524a-4cc3-b862-976e2718f398', // Unisantana
    '4ae9d0c2-1004-471e-a0ea-83057e3d956a', // degustação
  ];
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    addToast({
      type: 'success',
      title: 'Copiado!',
      description: 'Texto copiado para a área de transferência.',
    });
  };

  const handleDownload = () => {
    const blob = new Blob([iaText], { type: 'text/plain;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'atividade.txt';
    link.click();
  };

  const gerarAtividade = async () => {
    console.log('topic', topic);
    console.log('model', model);
    console.log('duration', duration);
    if (!topic || !model || !duration) {
      addToast({
        type: 'error',
        title: 'Atenção!',
        description: 'Preencha todos os campos obrigatórios.',
      });
      return;
    }

    setLoading(true);
    try {
      const prompt = `Você é um gerador de atividades síncronas mediadas. Com base no tema da aula e no modelo escolhido, crie uma atividade completa, seguindo a estrutura abaixo. Adapte a linguagem de forma clara e objetiva, e sempre inclua sugestões de variação.
        Tema da aula: ${topic}
        Modelo de atividade: ${model}
        Duração: ${duration}

        Estrutura da atividade:
        - Título da Atividade
        - Duração
        - Objetivos de Aprendizagem
        - Competências Desenvolvidas
        - Preparação
        - Desenvolvimento
        - Questões Norteadoras
        - Avaliação
        - Atividades de Extensão
        - Sugestão de Variação
        - Encerramento
        `;

      console.log('prompt', prompt);
      const data: any = await getAiResponse({ prompt });
      console.log('data', data);

      setIaText(data);
      setHasData(true);
    } catch (error) {
      console.error('Erro ao gerar:', error);
    } finally {
      setLoading(false);
    }
  };
  const sellerId = user?.seller?.id;

  if (!sellerId || !allowedSellersId.includes(sellerId)) {
    return (
      <div
        style={{
          width: '100%',
          padding: '20px 0',
          backgroundColor: '#fff3cd',
          borderBottom: '1px solid #ffeeba',
          textAlign: 'center',
          position: 'relative', // ou 'fixed' se quiser sempre visível
          top: 0,
          zIndex: 999,
        }}
      >
        <h4 style={{ color: '#856404', margin: 0 }}>Acesso Restrito</h4>
        <p style={{ margin: 0 }}>
          Entre em contato com o suporte para solicitar acesso.
        </p>
      </div>
    );
  }

  return (
    <FormWrapper>
      <h3>Informações Básicas</h3>

      <Label>Tema da Aula</Label>
      <Input
        type="text"
        value={topic}
        onChange={e => setTopic(e.target.value)}
        placeholder="Impactos da Inteligência Artificial na Educação"
      />
      <small>Informe o Tema principal que será abordado na atividade.</small>

      <Row>
        <Column>
          <Label>Modelo de Atividade</Label>
          <Select value={model} onChange={e => setModel(e.target.value)}>
            <option>Debate Estruturado</option>
            <option>Estudo de Caso Colaborativo</option>
            <option>Análise Crítica Colaborativa</option>
            <option>Seminário Virtual</option>
            <option>Resolução de Problemas</option>
            <option>Projeto Colaborativo</option>
          </Select>
        </Column>

        <Column>
          <Label>Duração Estimada</Label>
          <Select value={duration} onChange={e => setDuration(e.target.value)}>
            <option>60 Minutos</option>
            <option>90 Minutos</option>
            <option>120 Minutos</option>
            <option>180 Minutos</option>
          </Select>
        </Column>
      </Row>

      <Button onClick={gerarAtividade} disabled={loading}>
        <FiEdit3 style={{ marginRight: 8 }} />
        {loading ? 'Gerando...' : 'Gerar Atividade com IA'}
      </Button>

      {hasData && (
        <AlertWrapper>
          <textarea
            value={iaText}
            readOnly
            style={{ width: '100%', height: '200px', marginTop: 16 }}
          />
          <Row>
            <Button
              onClick={() => handleCopy(iaText)}
              style={{ marginTop: 16 }}
            >
              <FiCopy style={{ marginRight: 8 }} />
              Copiar Texto
            </Button>
            <Button onClick={handleDownload} style={{ marginTop: 16 }}>
              <FiDownload style={{ marginRight: 8 }} />
              Baixar Arquivo
            </Button>
          </Row>
        </AlertWrapper>
      )}
    </FormWrapper>
  );
};

export { IaActivities };
